const CODE = 'SoftwareTokenMfaRequired';

export class SoftwareTokenMfaRequiredError extends Error {

  constructor() {
    super(CODE);
    this['error'] = { code: CODE };
  }
}
